import { BsModalRef } from 'ngx-bootstrap/modal';
import { Component, Input } from '@angular/core';
import { FaefResultado } from '../../model/faef';

@Component({
  selector: 'app-modal-indicadores',
  templateUrl: './modal-indicadores.component.html',
  styleUrls: ['./modal-indicadores.component.scss']
})
export class ModalIndicadoresComponent {

  @Input() model: FaefResultado;

  constructor(public modal: BsModalRef) { }

}
